import React from "react";

const ExportToJSON = ({ rawData, financialInfo }) => {
const transformByDateAndClass = (data) => {
  const result = {};

  data.forEach(entry => {
    const { Class, "Item Description": itemDesc, ...dateValues } = entry;

    Object.entries(dateValues).forEach(([date, value]) => {
      if (!result[date]) result[date] = {};
      if (!result[date][Class]) result[date][Class] = [];

      result[date][Class].push({ item: itemDesc, value: value });
    });
  });

  // Transform to desired output structure
  return Object.entries(result).map(([date, statements]) => ({
    year: date,
    statements: {
      assets: statements["Assets"] || [],
      liabilitiesAndNetworth: statements["Liabilities & Networth"] || [],
      incomeStatement: statements["Income Statement"] || [],
      cashflow: statements["Cash Flow"] || [],
      analysis: statements["Analysis"] || [],
    }
  }));
};


  const handleDownload = () => {
    const groupedData = transformByDateAndClass(rawData);

    const fullJSON = {
      financialInfo,
      data: groupedData
    };


    const { AccountId, ClientId } = financialInfo;
    const filename = `${AccountId}_${ClientId}_financial_data.json`;

    const blob = new Blob([JSON.stringify(fullJSON, null, 2)], {
      type: "application/json"
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
    </>
  );
};

export default ExportToJSON;
